import { render, staticRenderFns } from "./LightweightMetaField.vue?vue&type=template&id=592a7f0b&scoped=true&"
import script from "./LightweightMetaField.vue?vue&type=script&lang=js&"
export * from "./LightweightMetaField.vue?vue&type=script&lang=js&"
import style0 from "./LightweightMetaField.vue?vue&type=style&index=0&id=592a7f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a7f0b",
  null
  
)

export default component.exports